

































































































import * as _ from 'lodash';
import dayJs from 'dayjs';
// @ts-ignore
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
import { multiLangStringCompare } from '@/main/utils/stringHelper';
import { EventBus } from '@/main/eventBus';
import { openEdit } from '@/main/router/routerPath';
import {
	cellNames,
	Cell,
	CellNamesObject,
	Column,
	getColumnsRowMapObject,
	getFlatColumns,
	Row,
	rowCloseEvent,
	Table,
	COLUMN_ID_INDEX,
	intToRgb,
} from '@/main/utils/table';
import { PageMode } from '@/main/utils/pageMode';

import {
	getModeOperations,
	OperationFlags,
} from '#components/dms/common/operationFlagsConstants';
import { DmsBaseComponent } from '#components/dms/common/base';
import DmsTableCell from '#components/dms/layout/TableCell.vue';
import DmsTableHeader from '#components/dms/layout/TableHeader.vue';

import DmsTableSetting from './TableSetting.vue';
import InfoSideBar from '../InfoSideBar/InfoSideBar.vue';
import ExpandedRow from './ExpandedRow.vue';

type Button = {
	icon: string;
	onClickAction: (e: Event, cells: Cell[]) => any;
	value: number;
	isVisible: (row: Row) => true,
};

export default DmsBaseComponent.extend({
	name: 'DmsTable',
	components: {
		InfoSideBar,
		DmsTableCell,
		DmsTableHeader,
		CollapseTransition,
		ExpandedRow,
		DmsTableSetting,
	},
	props: {
		decimalRequired: { type: Boolean, default: false },
		tableCellStyle: { type: Function, required: false },
		tableRowStyle: { type: Function, required: false },
		rowClassName: { type: Function, required: false },
		rowDetailOpenOnView: { type: Boolean, default: false },
		sideBarLoading: { type: Boolean, default: false },
		exportBtn: { type: Boolean, default: false },
		table: { type: Object as () => Table, required: true },
		rowKey: { type: String, default: COLUMN_ID_INDEX },
		selectRow: [String, Number],
		multipleSelection: Array,
		localizationOff: Boolean,
		extraButtons: {
			type: Object as () => Record<string, Button>,
			default: (): Object => ({}),
		},
		rowsOnPage: { type: Number, default: 20 },
		selectClickCallback: {
			type: Function,
			default: (instance: Vue) => {
				instance.$router.back();
			},
		},
		objectName: { type: String, default: undefined },
		isClickable: Boolean,
		tableDisabled: { type: Boolean, default: false },
		showFooter: { type: Boolean, default: true },
		showHeader: { type: Boolean, default: true },
		singleExpandedRow: { type: Boolean, default: false },
		extraOperationsAloved: { type: Number, default: 0 },
		hyperlinkColumn: { type: String, default: undefined },
	},
	data() {
		return {
			expandRowKeys: [] as string[],
			doReloadSelection: false,
			showInfoSideBar: false,
			clickedRow: null as Row | null,
			currentPage: 1,
			tableKey: 0,
			query: '',
			buttonsBase: {
				EDIT: {
					icon: 'el-icon-edit',
					onClickAction: (e: Event, cells: Cell[]) => (this as any).editClickAction(e, cells),
					value: OperationFlags.EDIT,
				},
				VIEW: {
					icon: 'el-icon-view',
					onClickAction: (e: Event, cells: Cell[]) => (this as any).viewClickAction(e, cells),
					value: OperationFlags.VIEW,
				},
				SELECT: {
					icon: 'el-icon-plus',
					onClickAction: (e: Event, cells: Cell[]) => (this as any).selectClickAction(e, cells),
					value: OperationFlags.SELECT,
				},
				PROCESS: {
					icon: 'el-icon-tickets',
					onClickAction: (e: Event, cells: Cell[]) => (this as any).processClickAction(e, cells),
					value: OperationFlags.PROCESS,
				},
				DELETE: {
					icon: 'el-icon-delete',
					onClickAction: (e: Event, cells: Cell[]) => (this as any).deleteClickAction(e, cells),
					value: OperationFlags.DELETE,
				},
			},
			sortInfo: {
				columnId: null,
				order: null as string | null,
			},
			timer: null as number | null,
		};
	},
	computed: {
		showRefresh(): boolean {
			return !(this.isListMode || this.isSelectList);
		},
		showExport(): boolean {
			return !(this.isListMode || this.isSelectList || this.exportBtn);
		},
		selection(): boolean {
			return (
				!!this.multipleSelection
				|| this.table.columns.some(
					(item: Column) => item.columnName === 'CHECKBOX',
				)
			);
		},
		isThereAtLeastOneButton(): boolean {
			return this.filteredRows.some(
				(row: Row) => this.operationsButtons(row.operations).length > 0,
			);
		},
		buttons(): Record<string, Button> | Object {
			return Object.assign({}, this.buttonsBase, this.extraButtons);
		},
		columnsVisible(): Column[] {
			return this.filterVisible(this.table.columns);
		},
		loadingCmp(): boolean {
			return this.table.loadingCount > 0;
		},
		total(): number {
			return this.filteredRows.length;
		},
		rowsOnCurrentPage(): Row[] {
			const startIndex = (this.currentPage - 1) * this.rowsOnPage;
			return this.sortedRows.slice(startIndex, startIndex + this.rowsOnPage);
		},
		sortedRows(): Row[] {
			if (!this.sortInfo.order || this.sortInfo.columnId === null || this.sortInfo.columnId === undefined) { return this.filteredRows; }
			return this.filteredRows.slice().sort(this.sortMethod);
		},
		filteredRows(): Row[] {
			return !this.query
				? this.table.rows
				: this.table.rows.filter((item: Row) => Object.values(item.cells).find((a) => this.findQuery(a)));
		},
		isPaginationNecessary(): boolean {
			return this.total > this.rowsOnPage;
		},
		getMaxOperations(): number {
			return Math.max(
				0,
				...this.rowsOnCurrentPage.map(
					(val) => this.operationsButtons(val.operations).length,
				),
			);
		},
		buttonsColumnSize(): string {
			const sum = this.getMaxOperations;
			// sirka tlacitka s lavym padding 34px + padding na konci v bunke 8px + border 1px, inak auto
			if (sum) {
				const a = 34 * sum;
				return (a + 8 + 1).toString();
			}
			return 'auto';
		},
		rowKeyCmp(): string {
			return `cells.${this.rowKey}`;
		},
		hasEditClickListener(): boolean {
			return !!this.$listeners && !!this.$listeners.editClick;
		},
		hasViewClickListener(): boolean {
			return !!this.$listeners && !!this.$listeners.viewClick;
		},
		hasCellClickListener(): boolean {
			return !!this.$listeners && !!this.$listeners.cellClick;
		},
		hasHyperLinkClickListener(): boolean {
			return (this.hyperlinkColumn !== undefined || this.hyperlinkColumn !== '') && (!!this.$listeners && !!this.$listeners.hyperLinkClick);
		},
		hasProcessClickListener(): boolean {
			return !!this.$listeners && !!this.$listeners.processClick;
		},
		hasDeleteClickListener(): boolean {
			return !!this.$listeners && !!this.$listeners['delete-click'];
		},
		hasDblClickListener(): boolean {
			return !!this.$listeners && !!this.$listeners['dblclick-row'];
		},
		objectNameCmp(): string | null {
			if (this.objectName) return this.objectName;
			if (this.$route.meta) return this.$route.meta.objectName;
			return null;
		},
		getNoDataText(): string {
			return this.table.emptyTextKey
				? this.Localize(this.table.emptyTextKey)
				: this.Localize('TableMsgNoData');
		},
		columnsFlat(): Column[] {
			return getFlatColumns(this.table.columns);
		},
		cellNamesCmp(): CellNamesObject {
			return cellNames(this.table);
		},
		hasRowColor(): boolean {
			return _.has(this.cellNamesCmp, 'ROWCOLOR');
		},
		saveSettingVisible(): boolean {
			return (
				!_.isNull(this.table.gridId) && !!this.$listeners['save-column-setting']
			);
		},
	},
	watch: {
		showInfoSideBar(newValue: boolean) {
			if (!newValue) {
				(this.$refs.singleTable as any).setCurrentRow(null);
			}
		},
		loadingCmp(newValue: number) {
			if (newValue === 0) {
				this.showInfoSideBar = false;
			}
		},
		'table.rows': function () {
			this.handleTableRowsChange();
		},
		currentPage() {
			this.doReloadSelection = true;
		},
	},
	created() {
		EventBus.$on('tableFilterQuery', (queryCmp: any) => {
			// Resetting current page to default, so that result will display from first page.
			this.currentPage = 1;
			this.query = queryCmp.toUpperCase();
		});
		EventBus.$on('sort-change', (sortingInfo: any) => {
			this.handleSortChange(sortingInfo);
		});
	},
	methods: {
		getButtonType(type: string) {
			return type || '';
		},
		reloadSelection() {
			this.$nextTick(() => {
				const selected = _.intersectionBy(
					this.rowsOnCurrentPage,
					this.multipleSelection,
					'cells[0]',
				);
				(this.$refs.singleTable as any).clearSelection();
				selected.forEach((row) => {
					this.doReloadSelection = true;
					(this.$refs.singleTable as any).toggleRowSelection(row);
				});
				this.doReloadSelection = false;
			});
		},
		pageChanged() {
			this.reloadSelection();
		},
		filterVisible(items: Column[]) {
			return _.filter(items, (item: Column) => item.isVisible);
		},
		getLocalization(text: string) {
			return this.localizationOff ? text : this.Localize(text);
		},
		getOperations(operations: number) {
			let baseOperations = this.tableDisabled
				? getModeOperations(PageMode.VIEW)
				: getModeOperations(this.pageMode, operations);
			// eslint-disable-next-line no-bitwise
			baseOperations |= operations & this.extraOperationsAloved;
			// eslint-disable-next-line no-bitwise
			return this.hasDeleteClickListener
				? baseOperations
				: baseOperations & ~OperationFlags.DELETE;
		},
		operationsButtons(operations: number) {
			return [
				...Object.keys(this.buttonsBase)
					// eslint-disable-next-line no-bitwise
					.filter(
						(button) => (this.buttonsBase as any)[button].value
							& this.getOperations(operations),
					),
				...Object.keys(this.extraButtons),
			];
		},
		buttonClick(button: Button, rowIndex: number, event: Event) {
			button.onClickAction(event, this.rowsOnCurrentPage[rowIndex].cells);
		},
		editClickAction(event: Event, cells: Cell[]) {
			if (this.hasEditClickListener) {
				const data = getColumnsRowMapObject(this.table.columns, cells);
				this.$emit('editClick', { event, data, mode: PageMode.EDIT });
			} else this.routeHandler(PageMode.EDIT, cells);
		},
		viewClickAction(event: Event, cells: Cell[]) {
			if (this.rowDetailOpenOnView) {
				this.showInfoSideBar = true;
				this.$emit('viewClick', cells);
			} else if (this.hasViewClickListener) {
				const data = getColumnsRowMapObject(this.table.columns, cells);
				this.$emit('viewClick', { event, data, mode: PageMode.VIEW });
			} else this.routeHandler(PageMode.VIEW, cells);
		},
		selectClickAction(event: Event, cells: Cell[]) {
			const data = getColumnsRowMapObject(this.table.columns, cells);
			this.$emit('selectedRow', { event, data });
		},
		processClickAction(event: Event, cells: Cell[]) {
			if (this.hasProcessClickListener) {
				const data = getColumnsRowMapObject(this.table.columns, cells);
				this.$emit('processClick', { event, data });
			} else this.routeHandler(PageMode.EDIT, cells);
		},
		deleteClickAction(event: Event, cells: Cell[]) {
			if (this.hasDeleteClickListener) {
				const data = getColumnsRowMapObject(this.table.columns, cells);
				this.$emit('delete-click', { name: this.table.name, event, data });
			} else {
				throw new Error('no deleteClick listener');
			}
		},
		routeHandler(mode: PageMode, cells: Cell[]) {
			const id = cells[0];
			if (!id) {
				return;
			}
			if (this.objectNameCmp) {
				openEdit(this.objectNameCmp, mode, { id });
			} else {
				this.$router.push(`${this.$router.currentRoute.path}/${mode}/${id}`);
			}
		},
		findQuery(rowItem: string | number) {
			return rowItem
				? rowItem.toString().toUpperCase().includes(this.query)
				: false;
		},
		handleSelectionChange(val: Row[]) {
			if (!this.doReloadSelection) {
				_.remove(this.multipleSelection as Row[], (i: Row) => this.rowsOnCurrentPage.some((t) => t === i));
				this.$emit('update:multipleSelection', [
					...val,
					...this.multipleSelection,
				]);
			} else {
				this.doReloadSelection = false;
			}
		},
		handleRowClick(row: Row, column: { type: string }) {
			if (column.type !== 'expand') {
				if (this.timer) {
					window.clearTimeout(this.timer!);
				}
				this.timer = window.setTimeout(() => {
					this.rowDetail(row);
					window.clearTimeout(this.timer!);
				}, 250);
			}
		},
		rowDetail(row: Row) {
			this.clickedRow = row;
			if (!this.rowDetailOpenOnView) {
				this.showInfoSideBar = true;
			}
			this.$emit('sideBarSelectRow', row.cells);
		},
		dblClickSelect(row: Row, column: any, event: Event) {
			window.clearTimeout(this.timer!);
			if (this.hasDblClickListener) {
				this.$emit('dblclick-row', row.cells);
			} else {
				const canEdit = this.operationsButtons(row.operations).includes('EDIT');
				const canView = this.operationsButtons(row.operations).includes('VIEW');
				const canSelect = this.operationsButtons(row.operations).includes(
					'SELECT',
				);
				if (canEdit) {
					this.editClickAction(event, row.cells);
				} else if (canSelect) {
					this.selectClickAction(event, row.cells);
				} else if (canView) {
					this.viewClickAction(event, row.cells);
				}
			}
		},
		handleCurrentChange(row: Row) {
			this.clickedRow = row;
			if (!row) return;
			if (this.rowKey && this.selectRow) {
				this.$emit('update:selectRow', row.cells[this.rowKey as any]);
			}
			this.$emit('currentChange', row.cells);
		},
		hasVisibleInnerColumn(column: Column) {
			return (_.has(column, 'columns') && _.filter(column.columns, { isVisible: true }).length > 0);
		},
		sortMethod(row0: Row, row1: Row) {
			if (!this.sortInfo.order || this.sortInfo.columnId === null || this.sortInfo.columnId === undefined) return 0;

			const { valueType } = this.columnsFlat[this.sortInfo.columnId!];
			let val0 = row0.cells[this.sortInfo.columnId!];
			let val1 = row1.cells[this.sortInfo.columnId!];

			this.sortInfo.order === 'descending' && ([val0, val1] = [val1, val0]);

			if ((['DateTime', 'Date', 'Time'] as (string | null)[]).includes(valueType)) { return (dayJs(val0) as any) - (dayJs(val1) as any); }
			if (valueType === 'String') return multiLangStringCompare(val0, val1);

			return val0 - val1;
		},
		handleSortChange({ columnId, order, name }: { columnId: any; order: string, name: string }) {
			if (this.table.name === name) {
				this.$emit('sort-change', { columnId, order }, this.table.name);
				this.sortInfo.columnId = columnId;
				this.sortInfo.order = order;
			}
		},
		handleCellClick(row: any, column: any, cell: any) {
			if (cell) {
				const isHyperLinkColumn = cell.querySelector('.hyperlink-cell');
				if (this.hasHyperLinkClickListener && isHyperLinkColumn && this.hyperlinkColumn in this.table.cellNames!) {
					this.$emit('hyperLinkClick', { cellNames: this.table.cellNames, row: row as Row });
				}
			}

			if (this.hasCellClickListener) {
				this.$emit('cellClick', { row, column, cell });
			}
			if (column.type === 'expand') {
				this.handleRowExpandClick(row, cell);
			}
		},
		handleRowExpandClick(row: any, cell: any) {
			const rowKey = this.getRowKey(row);
			const isOpen = this.expandRowKeys.includes(rowKey);
			if (isOpen) {
				this.handleRowClose(rowKey, cell);
			} else {
				this.handleRowOpen(row, rowKey, cell);
			}
		},
		handleRowClose(rowKey: string, cell: Cell) {
			EventBus.$emit(rowCloseEvent(rowKey));
			const expandIcon = cell.getElementsByClassName(
				'el-icon el-icon-arrow-right',
			)[0];
			setTimeout(() => {
				expandIcon.click();
				this.expandRowKeys = this.expandRowKeys.filter(
					(expandedRowKey) => expandedRowKey !== rowKey,
				);
				this.$emit('update:expanded-row', null);
			}, 300);
		},
		handleRowOpen(row: Row, rowKey: string, cell: Cell) {
			const openRow = () => {
				this.$emit('update:expanded-row', row);
				this.expandRowKeys.push(rowKey);
			};
			if (this.singleExpandedRow && this.expandRowKeys.length > 0 && this.expandRowKeys[0] !== rowKey) {
				this.handleRowClose(this.expandRowKeys[0], cell);
				setTimeout(() => {
					openRow();
				}, 300);
			} else {
				openRow();
			}
		},
		getRowKey(row: Row) {
			return `${_.get(row, this.rowKeyCmp)}`;
		},
		handleTableRowsChange() {
			this.currentPage = 1;
		},
		refreshLayout() {
			this.tableKey += 1; // rerender table component
		},
		updateColumnsSetting({
			visibles,
			columns,
		}: {
			visibles: boolean;
			columns: Column[];
		}) {
			const hasntCol = (col: Column) => !columns.some((vcol) => vcol.columnId === col.columnId);
			const filtered = this.table.columns.filter(hasntCol);

			this.table.columns = visibles
				? [...columns, ...filtered]
				: [...filtered, ...columns];
			this.refreshLayout();
		},
		saveColumnSetting(columns: string) {
			this.$emit('save-column-setting', columns);
		},
	},
});
